<!--This component (step 1) to choose reservation type and number persons-->
<template>
	<v-card-text>
		<v-row>
			<!--Start Welcome Content-->
			<v-col cols="12">
				<div
					v-if="
						this.config &&
							this.config.welcome_page &&
							this.config.welcome_page.welcome_title_status != null &&
							this.config.welcome_page.welcome_title_status != false
					"
					class="py-6"
				>
					<div v-html="config.welcome_page.welcome_title" class="rich-text rich-text--center"></div>
				</div>

				<div
					v-if="
						config.welcome_page &&
							config.welcome_page.welcome_body_status != null &&
							config.welcome_page.welcome_body_status != false
					"
					class="py-6"
				>
					<div v-html="config.welcome_page.welcome_body" class="rich-text rich-text--center"></div>
				</div>

				<div
					v-if="
						config.welcome_page &&
							config.welcome_page.welcome_alert_status != null &&
							config.welcome_page.welcome_alert_status != false
					"
				>
					<v-alert
						type="success"
						:color="config.welcome_page.welcome_alert_color"
						outlined
						prominent
						:value="true"
						class="ma-0"
					>
						{{ config.welcome_page.welcome_alert }}
					</v-alert>
				</div>
			</v-col>
			<!--End Welcome Content-->

			<!--Start Reservation Types Card-->
			<v-col cols="12">
				<div
					v-if="
						this.config &&
							this.config.welcome_page &&
							this.config.welcome_page.reservationTypeBodyStatus != null &&
							this.config.welcome_page.reservationTypeBodyStatus != false
					"
					v-html="config.welcome_page.reservationTypeBody"
					class="rich-text mb-2"
				></div>

				<!--loader-->
				<div class="text-center">
					<v-progress-circular indeterminate v-if="loading" color="primary" size="128" />
				</div>

				<v-item-group v-model="reservationTypeUuid" class="fade-transition-enter-active" mandatory>
					<v-container class="px-0">
						<v-row>
							<v-col cols="12" sm="6" v-for="reservationType in reservationTypes" :key="reservationType.uuid">
								<v-item v-slot="{ active, toggle }" :value="reservationType.uuid">
									<div
										style="border-style: solid; border-width: 2px; border-color: transparent;"
										:class="active ? 'primary' : ''"
									>
										<v-card
											:color="active ? 'primary lighten-5' : ''"
											class="d-flex align-center"
											height="100"
											@click="toggle"
											outlined
											tile
										>
											<v-list-item three-line>
												<v-list-item-avatar tile size="80">
													<v-icon x-large :color="reservationType.color">
														fa-{{ reservationType.icon }}
													</v-icon>
												</v-list-item-avatar>

												<v-list-item-content>
													<v-list-item-title class="font-weight-regular w-100" width="100%">
														{{ reservationType.name }}
													</v-list-item-title>

													<!--<v-list-item-subtitle>
                              Greyhound divisely hello coldly
                            </v-list-item-subtitle>

                            <v-list-item-subtitle></v-list-item-subtitle>-->
												</v-list-item-content>
											</v-list-item>
										</v-card>
									</div>
								</v-item>
							</v-col>
						</v-row>
					</v-container>
				</v-item-group>

				<!--***-->
			</v-col>
			<!--End Reservation Types Card-->

			<!--Start Number Persons input-->
			<v-col v-if="reservationTypeUuid != '' && reservationTypeUuid != null" cols="12">
				<v-form ref="form" v-model="valid" lazy-validation>
					<v-text-field
						ref="numberPersons"
						v-model="numberPersons"
						:label="$t('generic.lang_number_persons')"
						placeholder=""
						outlined
						type="Number"
						:min="1"
						:rules="rules"
						:error-messages="errorMessages"
						@input.native="onInputNumbers"
						@paste.native="onPasteNumbers"
					>
						<v-icon slot="prepend-inner" class="mr-4" color="primary">
							mdi-account-group
						</v-icon>
					</v-text-field>
				</v-form>
			</v-col>
			<!--End Number Persons input-->
		</v-row>
	</v-card-text>
</template>

<script>
/*import plugins*/
import { createNamespacedHelpers } from "vuex";
import inputSanitizer from "@/mixins/inputSanitizer";

export default {
	name: "Step1Component",

	mixins: [inputSanitizer],

	data() {
		return {
			valid: true,
			errorMessages: "",

			rules: [
				(v) => !!v || this.$t("generic.lang_requiredField"),
				(v) => !isNaN(v),
				(v) => (v && v >= 1) || this.$t("generic.lang_numberPersonsShouldBeAbove0"),
			],
		};
	},

	computed: {
		//map loader getters
		...createNamespacedHelpers("loader").mapGetters(["loading"]),
		...createNamespacedHelpers("reservationTypes").mapGetters([
			"reservationTypes",
			"maxPersons",
			"oldReservationTypeUuid",
		]),

		reservationTypeUuid: {
			get() {
				return this.$store.state.reservationTypes.reservationTypeUuid;
			},
			set(val) {
				this.$store.commit("reservationTypes/addReservationType", val);
			},
		},

		numberPersons: {
			get() {
				return this.$store.state.reservationTypes.numberPersons;
			},
			set(val) {
				this.$store.commit("reservationTypes/addNumberPersons", this.cleanNumbers(val));
			},
		},

		config() {
			return this.$store.getters["config/config"] || {};
		},
	},

	watch: {
		numberPersons(val) {
			if (val > this.maxPersons) {
				this.errorMessages =
					this.$t("generic.lang_maxShouldNotBeAbove") +
					" " +
					this.maxPersons +
					" " +
					this.$t("generic.lang_persons");
			} else if (val === "" || val === null) {
				this.errorMessages = this.$t("generic.lang_requiredField");
			} else if (val < 1) {
				this.errorMessages = this.$t("generic.lang_numberPersonsShouldBeAbove0");
			} else {
				this.errorMessages = "";
			}
		},
	},

	methods: {
		validate() {
			if (this.numberPersons <= this.maxPersons) {
				if (
					this.$refs.form.validate() === true &&
					this.reservationTypeUuid != "" &&
					this.reservationTypeUuid != null
				) {
					if (this.reservationTypeUuid != this.oldReservationTypeUuid) {
						this.$store.commit("reservationTypes/addOldReservationType", this.reservationTypeUuid);
						this.$store.commit("tables/addTables", []);
						this.$store.commit("items/addSelectedItems", []);
					}

					return true;
				}
			}

			return false;
		},
	},
};
</script>

<style>
/* Chrome, Safari, Edge, Opera */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Firefox */
input[type="number"] {
	-moz-appearance: textfield;
}

/* removing some default styles */
.v-application p {
	margin-bottom: 0 !important;
}

.ql-editor {
	all: initial;
}
</style>
